import React, { Component } from 'react'
import request from '../../../lib/requester'
import _ from 'lodash'
import ReactTable from "react-table"
import { Loader } from "react-overlay-loader";
import moment from 'moment'

class ListReject extends Component {
  constructor(props) {
    super(props)
    this.state = {
      dataTable: [],
      loading: false,
      selectedClaim: [],
      selectedProgram: '',
      selectedInvoice: '',
      lovProgram: [],
      lovInvoice: [],
      success: '',
      error: []
    }
  }

  componentDidMount = () => {
    this.getProgram()
    this.getInvoice()
  }

  getInvoice = () => {
    let url = '/api/traces_chd/v1/payment/list-invoice'
    let param = {
      status: 'D'
    }
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        this.setState({ lovInvoice: data })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  getProgram = () => {
    let url = '/api/traces_chd/v1/payment/list-program?type=reject'
    let param = {}
    this.setState({ loading: true })

    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        this.setState({ lovProgram: data, loading: false })
      }.bind(this),
      error: function (e) {
        console.log(e.message)
      }
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return <li key={index}><i class="fas fa-exclamation-triangle" /> {item}</li>;
            })}
          </ul>
        </div>
      );
    }
  }

  getList = (programId) => {
    let url = '/api/traces_chd/v1/payment/list-reject?programId=' + (programId || '')
    let param = {}
    this.setState({ loading: true })
    request.postCHD(url, param, {
      success: function (response) {
        let { data } = response.data
        this.setState({ dataTable: data, loading: false })
      }.bind(this),
      error: function (e) {
        console.log(e)
      }.bind(this)
    })
  }

  handleSelectClaim = (value) => {
    let { selectedClaim } = this.state;
    let findIndex = _.findIndex(selectedClaim, function (o) {
      return o === value;
    });
    if (findIndex < 0) {
      selectedClaim.push(value);
    } else {
      selectedClaim.splice(findIndex, 1);
    }
    this.setState(selectedClaim);
  };

  renderTable = () => {
    let app = this
    const data = {
      columns: [
        {
          Header: '',
          accessor: 'claim_number',
          width: 30,
          Cell: (row) => {
            let findIndex = _.findIndex(app.state.selectedClaim, function (o) {
              return o === row.value
            });
            let checked = findIndex >= 0 ? true : false;
            return (
              <span>
                <input
                  type="checkbox"
                  value={row.value}
                  onChange={() => { app.handleSelectClaim(row.value) }}
                  checked={checked}
                />
              </span>
            )
          }
        },
        {
          Header: 'CLAIM NO',
          accessor: 'claim_number',
          filterable: true,
          width: 200
        },
        {
          Header: 'CLAIM DATE',
          accessor: 'creation_date',
          filterable: true,
          Cell: function (row) {
            return (
              <span>{moment(row.value).format('DD-MMM-YYYY')}</span>
            )
          }
        },
        {
          Header: 'PROGRAM TYPE',
          accessor: 'program_name',
          filterable: true
        },
        {
          Header: 'PROGRAM DESC',
          accessor: 'description',
          filterable: true
        },
        {
          Header: 'AMOUNT',
          accessor: 'total',
          filterable: true
        },
        {
          Header: 'BANK',
          accessor: 'bank',
          filterable: true
        },
        {
          Header: 'BANK ACC NO',
          accessor: 'no_rekening',
          filterable: true
        },
        {
          Header: 'BANK ACC OWNER',
          accessor: 'bank_acc_owner',
          filterable: true
        },
        {
          Header: 'REASON',
          accessor: 'payment_reject_reason',
          filterable: true
        },
      ],
      rows: this.state.dataTable
    }
    return (<ReactTable
      className="fullWidth"
      data={data.rows}
      columns={data.columns}
      defaultPageSize={10}
    />)
  }

  handleSubmit = () => {
    let { selectedClaim, selectedInvoice, selectedProgram } = this.state
    if (selectedClaim.length === 0) {
      alert('Claim is required')
      return false
    }
    let param = {
      selectedProgram: selectedProgram,
      selectedInvoice: selectedInvoice,
      claim: selectedClaim,
    }

    if (window.confirm('Confirm Request Payment?')) {
      this.setState({ loading: true })
      request.postCHD('/api/traces_chd/v1/payment/submit-oracle?type=resubmit', param, {
        success: function (response) {
          let { message } = response.data
          this.setState({ loading: false, success: message || 'Data has been submitted to oracle', selectedClaim: [] })

          window.setTimeout(() => {
            window.location.reload()
          }, 2000)
        }.bind(this),
        error: function (e) {
          this.setState({ loading: false })
        }.bind(this)
      })
    }
  }

  handleChangeProgram = (e) => {
    let value = e.target.value || ''
    this.setState({ selectedProgram: value })
  }

  handleFind = () => {
    let split = this.state.selectedProgram.split('#')
    let programId = split[3] || '0'
    this.getList(programId)
  }

  handleChangeInvoice = e => {
    let v = e.target.value
    this.setState({ selectedInvoice: v })
  }
  
  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    {this.showNotification()}
                    <div className="row mt-2">
                      <div className="col-md-4">
                        <select className="form-control" onChange={this.handleChangeProgram.bind(this)}>
                          <option value="">- Select Program -</option>
                          {
                            this.state.lovProgram.map((item, index) => (
                              <option value={item.program_title + '#' + (moment(item.start_date).format('DD-MMM-YYYY')) + '#' + (moment(item.end_date).format('DD-MMM-YYYY')) + '#' + item.program_id}>{item.program_title}</option>
                            ))
                          }
                        </select>
                      </div>
                      <div className="col-md-2">
                        <button type="button" className="btn btn-info btn-block" onClick={this.handleFind.bind(this)} ><i className="fa fa-search" /> Find</button>
                      </div>
                      <div className="col-md-2">
                        <button type="button" className="btn btn-success btn-block" onClick={this.handleSubmit.bind(this)}><i className="fa fa-check" /> Re-submit</button>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-12">
                        {this.renderTable()}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    )
  }
}

export default ListReject